import styled from 'styled-components';

export const Container = styled.div`
  .infos {
    & > p:first-child {
      margin-bottom: 16px;
    }
  }
`;
